import { useState } from 'react';

export const useFilterPanels = () => {
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [showSortPanel, setShowSortPanel] = useState(false);

  const toggleFilterPanel = () => {
    setShowFilterPanel(prev => !prev);
    setShowSortPanel(false); // Close sort panel when opening filter panel
  };

  const toggleSortPanel = () => {
    setShowSortPanel(prev => !prev);
    setShowFilterPanel(false); // Close filter panel when opening sort panel
  };

  const closeFilterPanel = () => {
    setShowFilterPanel(false);
  };

  return {
    showFilterPanel,
    showSortPanel,
    toggleFilterPanel,
    toggleSortPanel,
    closeFilterPanel
  };
};
